import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/PhoneCountryCode/GetAllForDropdown";

        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "PHONE_COUNTRY_CODES_RETRIEVED",
                        phoneCountryCodes: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
